module.exports = __webpack_public_path__ + "static/img/1_7_3.f9ce6245.jpg";